import { Box } from "@react-three/flex";
import LanguageBox from "../Boxes/LanguageBox";
import LibraryBox from "../Boxes/LibraryBox";


function PageTwo({ scale, handleThreshold, viewport }) {

  return (
    <>
      <LanguageBox 
        scale={scale}
        onReflow={handleThreshold}
        align='center'
      />
    </>
  );
};

export default PageTwo;